module.exports = __webpack_public_path__ + "static/img/group-banner.ac3f56c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-banner.jpg
// module id = Jwat
// module chunks = 1